import React from 'react';
import { buildQuoteDetails } from './clientReportingQuoteDetails';

/**
 * Body of the watchlist hover box: the full quote, spelled out.
 *
 * Deliberately verbose about units and period. The bare pill on the row can
 * only fit "+0.54%", which does not say over what window or in what unit —
 * this is where that gets answered.
 */
export default function ClientReportingQuoteTip({
  title,
  subtitle,
  quote,
  kind,
  currencyPrefix,
}) {
  if (!quote) return null;
  const details = buildQuoteDetails(quote, { kind, currencyPrefix });

  return (
    <>
      <div className="vd-ml-quote-tip-head">
        <span className="vd-ml-quote-tip-title">{title}</span>
        {subtitle ? <span className="vd-ml-quote-tip-sub">{subtitle}</span> : null}
      </div>

      <dl className="vd-ml-quote-tip-rows">
        {details.rows.map((row) => (
          <div className="vd-ml-quote-tip-row" key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>

      {details.ranges.map((range) => (
        <div className="vd-ml-quote-tip-range" key={range.key}>
          <div className="vd-ml-quote-tip-row">
            <dt>{range.label}</dt>
            <dd>{range.value}</dd>
          </div>
          {/* Where the current price sits in the range, so "is this high or
              low for the period?" is answerable without doing the arithmetic. */}
          {range.position != null ? (
            <div className="vd-ml-quote-tip-track">
              <span
                className="vd-ml-quote-tip-marker"
                style={{ left: `${range.position}%` }}
              />
            </div>
          ) : null}
        </div>
      ))}

      <p className="vd-ml-quote-tip-note">{details.footnote}</p>
      {details.asOf ? (
        <p className="vd-ml-quote-tip-stamp">
          {details.delayed ? 'Delayed quote · ' : ''}
          as of {details.asOf}
        </p>
      ) : null}
    </>
  );
}
